




















import { Component, Vue, Prop } from "vue-property-decorator";
import { MenuItem } from "shared/bootstrap";
import { namespace } from "vuex-class";

const authStore = namespace("auth");

@Component
export default class MainMenu extends Vue {
  @authStore.Getter("loggedIn") loggedIn!: boolean;

  @Prop({ required: true })
  items!: MenuItem[];

  @Prop({ default: false })
  topDivider!: boolean;

  get seperatedItems() {
    let filtered: MenuItem[];
    if (this.loggedIn) {
      filtered = this.items.filter(item => !item.hideAuth);
    } else {
      filtered = this.items.filter(item => !item.hideNoAuth);
    }

    return [
      filtered.filter(item => item.top),
      filtered.filter(item => !item.top && !item.bottom),
      filtered.filter(item => item.bottom)
    ];
  }

  deviderNeeded(i: number) {
    return (
      this.seperatedItems[i].length > 0 &&
      i > 0 &&
      this.seperatedItems[i - 1].length > 0
    );
  }
}
